import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import { share } from 'rxjs/operators';
import { HttpResponseHandlerService } from './http-response-handler.service';
import { environment } from '../../environments/environment';

@Injectable()
export class HostedCashierPaymentsService {

  getPendingWithdrawal_url ='/api/user/transaction/:merchantId/:userId';
  cancelTransaction_url='/api/user/transaction/:merchantId/:userId/:transactionId';
  profileBalanceCurrency:any=null;
  tokenDetail:any=null;

  constructor(
    private http: HttpClient, 
    private httpResponseHandlerService:HttpResponseHandlerService
  ) { }
  

  /**
   * @param url endpoint url
   * @param queryParams optional query params
   */
  piqGet(url, queryParams?): Observable<any> {
    return this.http.get(environment.paymentIqUrl + url, { params: queryParams,
      observe: 'body'
    });
  }

  piqPost(url, requestBody): Observable<any> {
    return this.http.post(environment.paymentIqUrl + url, requestBody);
  }

  piqDelete(url, queryParams): Observable<any> {
    return this.http.delete(environment.paymentIqUrl + url, { params: queryParams,
      observe: 'body'
    });
  }

  psGet(searchParams,url):Observable<any>{
    return this.http.get(environment.apiUrl+url,{withCredentials: true,params:searchParams});
  }

  pidtokenCallStack:Subscriber<any>[]=[];
  getTokenPaymentIQ(token){

    //if(this.tokenDetail) return of(this.tokenDetail);

    return new Observable((resolve)=>{

      if(this.pidtokenCallStack.length>0){
        this.pidtokenCallStack.push(resolve);
      }else{

        this.pidtokenCallStack.push(resolve);
        this.psGet('', '/ajax/token/getToken?token=cashier').subscribe((data)=>{
          this.tokenDetail=data;
          for (let callback in  this.pidtokenCallStack){
            this.pidtokenCallStack[callback].next(this.tokenDetail);
          }
          this.pidtokenCallStack=[];
        });
      }
    });
    
  }

  getPendingWithdrawal(requestPiqObj): Observable<any>{
    const pendigWithdrawUrl = this.getPendingWithdrawal_url
      .replace(':merchantId', requestPiqObj.merchantId)
      .replace(':userId', requestPiqObj.userId)
    delete requestPiqObj.merchantId;
    delete requestPiqObj.userId;
    return this.piqGet(pendigWithdrawUrl, requestPiqObj);
  }

  cancelTransaction(requestPiqObj): Observable<any>{
    const cancelTransactionUrl = this.cancelTransaction_url
      .replace(':merchantId', requestPiqObj.merchantId)
      .replace(':userId', requestPiqObj.userId)
      .replace(':transactionId', requestPiqObj.transactionId)
    delete requestPiqObj.merchantId;
    delete requestPiqObj.userId;
    delete requestPiqObj.transactionId;
    return this.piqDelete(cancelTransactionUrl, requestPiqObj);
  }

}
